import { BaseApiService } from '@/shared/api/services/base.service';
import type { PassesResponse } from '@/types/passes';

/**
 * Tokens Pro Pass catalog. Copy (name, features, price, is_active) is fully
 * resolved server-side per MONETIZATION_PIVOT principle 5 — the client renders
 * it verbatim. Display-only today; the Stripe Checkout purchase flow is a later
 * pivot task (D1/D2).
 */
/**
 * Paddle customer-portal descriptor (GET /v1/paddle/portal). The URLs are
 * TEMPORARY — signed, short-lived. Fetch a fresh one on every click and open
 * it in a new browser tab; never cache and never iframe (Paddle blocks
 * framing, and a stale URL 401s).
 */
export interface PaddlePortalResponse {
  data: {
    attributes: {
      url: string;
      cancel_url: string | null;
    };
  };
}

class PassesService extends BaseApiService {
  async getPasses(): Promise<PassesResponse> {
    return this.httpGet<PassesResponse>('/v1/passes');
  }

  async getPaddlePortal(): Promise<PaddlePortalResponse> {
    return this.httpGet<PaddlePortalResponse>('/v1/paddle/portal');
  }
}

export const passesService = new PassesService();
